class CollapseTags {
  start() {
    const buttonsMore = document.querySelectorAll('.collapse-tag-show');
    buttonsMore.forEach((item) => {
      item.addEventListener('click', toogleColapse);
    });
  }
}

function toogleColapse(e) {
  const dataOpen = Number(e.currentTarget.dataset.open);
  const parent = e.currentTarget.closest('.collapse-tags-block');
  if (dataOpen === 0) {
    const hiddenTags = parent.querySelectorAll('.collapse-tag-hidden');
    hiddenTags.forEach((item) => {
      item.style.display = 'block';
    });
    e.currentTarget.dataset.open = '1';
    const collapseImg = parent.querySelector('.collapse-tag-show-img');
    collapseImg.style.transform = 'rotate(180deg)';
  } else {
    const hiddenTags = parent.querySelectorAll('.collapse-tag-hidden');
    hiddenTags.forEach((item) => {
      item.style.display = 'none';
    });
    e.currentTarget.dataset.open = '0';
    const collapseImg = parent.querySelector('.collapse-tag-show-img');
    collapseImg.style.transform = 'rotate(0deg)';
  }
}

module.exports = CollapseTags;
